// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Google OAuth provider
import { GoogleOAuthProvider } from '@react-oauth/google';

// Cliente Axios centralizado (baseURL, interceptores, token)
import API from './api/client';

// React Query Provider centralizado con configuración y Devtools
import { ReactQueryProvider } from './lib/queryClient';
//import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {/* Ahora usamos nuestro ReactQueryProvider que envuelve QueryClientProvider */}
      <ReactQueryProvider>
        <App />
        {/* <ReactQueryDevtools initialIsOpen={true} /> */}
      </ReactQueryProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// Log de la base URL para depuración en build
console.log('🔗 Base API URL (build):', API.defaults.baseURL);

// Si quieres medir rendimiento, pasa reportWebVitals(console.log) o envíalo a tu analítica
reportWebVitals();
